export const isBlankGuestCount = (value) => value == null || String(value).trim() === '';

export const isGuestCountValid = (value, required) => {
  if (isBlankGuestCount(value)) return !required;
  return !isNaN(Number(value)) && Number(value) >= 0;
};
